import {
  wordpressVersionAction,
  LOAD_WP_VERSION, LOAD_WP_VERSION_FAIL,
  LOAD_WP_VERSION_SUCCESS,
  LoadWordpressVersion,
  LoadWordpressVersionFail,
  LoadWordpressVersionSuccess
} from "../actions";


export interface IWebsiteWPVersionEntityState {
  entities: {[websiteId: number]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IWebsiteWPVersionState {
  entities: {[websiteId: number]: IWebsiteWPVersionEntityState};
}

export const initialState: IWebsiteWPVersionState = {
  entities: {}
};

export function reducer(state: IWebsiteWPVersionState = initialState, action: wordpressVersionAction): IWebsiteWPVersionState {
  let payload: any;

  switch (action.type) {

    case LOAD_WP_VERSION:
      payload = (<LoadWordpressVersion>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_WP_VERSION_SUCCESS:
      payload = (<LoadWordpressVersionSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_WP_VERSION_FAIL:
      payload = (<LoadWordpressVersionFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
